var map = {
	"./Banner.svg": "9873",
	"./Header.png": "ee6d",
	"./Industrial.png": "430f",
	"./analytics.png": "3440",
	"./bafang.png": "c2c4",
	"./british american tobacco.png": "fb61",
	"./case1.svg": "6f36",
	"./case2.svg": "35d3",
	"./case3.svg": "ab6b",
	"./chinese1.png": "55e6",
	"./chinese2.png": "340b",
	"./cloud-infastructure.svg": "6bc5",
	"./deaon.png": "1bdb",
	"./deutsche bank.png": "df8c",
	"./develope.svg": "a53a",
	"./gjdl.png": "8670",
	"./guangfu eletronics.png": "a533",
	"./hsbc.png": "329e",
	"./image 20.png": "eb6d",
	"./image 21.png": "8ad9",
	"./image 22.png": "7ea7",
	"./image 23.png": "b8b6",
	"./image 24.png": "b2ca",
	"./image 25.png": "b162",
	"./image 26.png": "222f",
	"./image 27.png": "7475",
	"./image 28.png": "5103",
	"./image 29.png": "27a8",
	"./image 30.png": "4ab6",
	"./intarlinks.png": "2ad2",
	"./johnson and johnson.png": "2371",
	"./jpmc.png": "0a0d",
	"./linkedin.png": "beb0",
	"./mobile.png": "58b8",
	"./moodys.png": "a059",
	"./pb1.png": "e4f0",
	"./pb2.png": "55e4",
	"./pb3.png": "962f",
	"./pb4.png": "9819",
	"./pb5.png": "3903",
	"./pb6.png": "f043",
	"./pb7.png": "13d3",
	"./pb8.png": "25eb",
	"./pb9.png": "6489",
	"./rbs.png": "6ae5",
	"./red-circle-internet.svg": "0449",
	"./red-circle-mobile.svg": "6012",
	"./red-circle-rocket.svg": "dc5b",
	"./red-circle-website.svg": "1e76",
	"./send.svg": "e141",
	"./service-area1.png": "0061",
	"./service-area1.svg": "abf2",
	"./service-area2.png": "e7c2",
	"./service-area3.png": "7a91",
	"./ssc.png": "b695",
	"./vzp.png": "2bde",
	"./wechat.png": "37c4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";